export default __webpack_public_path__ + "static/media/cointelegraph-logo-white.a1805e8c.svg";